<template>
  <div class="outer-layer">
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
      <component v-if="isRouterAlive" ref="pub" :is="currentTab" :currentTab='currentTab' :batchStatus="batchStatus"></component>
    </bsp-tabs>
  </div>
</template>
<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
  import applyList from "@/views/agreement/fintax/apply/finTaxAgreementApplyList";
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters(['userInfo']),
    },
    created(){
      console.log("当前用户 机构id：" + this.userInfo.orgId);
      this.tabList = [{
        title: '协议新建申请',
        name: '33730001'
      }, {
        title: '协议修改申请',
        name: '33730002'
      }, {
        title: '协议终止申请',
        name: '33730003'
      }];
      this.tabIndex = this.$route.query.currentTab ? this.$route.query.currentTab : '33730001';
      this.currentTab = this.tabIndex;
    },
    data() {
      return {
        tabList:[],
        tabIndex: "",
        currentTab:"",
        isRouterAlive:true,
      }
    },
    provide(){
      return{
        reload:this.reload
      }
    },
    components:{
      bspTabs,
      33730001: applyList,
      33730002: applyList,
      33730003: applyList,
    },
    methods: {
      changeTab(tab, event) {
        this.currentTab = tab.name;
        this.reload();
        console.log("hello everybody~~~this.currentTab==");
        console.log(this.currentTab);
      },
      reload (){
        this.isRouterAlive = false
        this.$nextTick(function(){
          this.isRouterAlive = true
        })
      }
    }
  }
</script>
